import 'styles/common/form.scss';

import classNames from 'classnames';
import React from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';

import Checkbox from './Form/Checkbox';
import Input from './Form/Input';
import PillCheckbox from './Form/PillCheckbox';
import Select from './Form/Select';
import Submit from './Form/Submit';
import Textarea from './Form/Textarea';
import TranslatedField from './Form/TranslatedField';

export {
  Field,
  TranslatedField,
  reduxForm,
  SubmissionError,
  Checkbox,
  Input,
  PillCheckbox,
  Select,
  Submit,
  Textarea,
};

export const Form = props => (
  <form className={classNames('Form', props.className)} {...props}>
    {props.children}
  </form>
);



// WEBPACK FOOTER //
// ./app/javascript/common/components/Form.js